import React from 'react'
import { Item } from '../../../../common/snippets'
import { Box, Button, InputAdornment, TextField, Typography } from '@mui/material'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import DropDownOA from '../../../../common/dropDownOA'
import SearchIcon from '@mui/icons-material/Search';
import WeightChrgTable from './WeightChrgTable'
import { connect } from 'react-redux'
import { updateModal, updateAlertError } from '../../../../../store/common/common_action'
import { getWeightChrg, updateWeightChrg } from '../../../../../store/generalSetting/GSAction'
import * as mdt from '../../../../common/modaltypes'
import WeightChrgModal from './WeightChrgModal'
import { useState } from 'react'
import { focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../../common/helper'
import { useEffect } from 'react'
import ConfirmModal from './ConfirmModal'
import { useTranslation } from '../../../../../i18n/I18nProvider'

const WeightCharges = (props) => {
    const { data: { common },
        updateModal,
        updateAlertError,
        getWeightChrg,
        updateWeightChrg
    } = props
    const { loginData, showModal, modalType, cnsgnmntTypes } = common
    const { translations, language } = useTranslation()
    const gs = translations?.generalSettings || {}
    const tr = (key, fallback) => gs?.[key] || fallback
    const consignmentTypesWithAll = cnsgnmntTypes.length > 0
        ? [{ ConsignmentSubTypeID: 0, SubType: tr('gsAll', 'All') }, ...cnsgnmntTypes]
        : []
    const [selConsignmentType, setSelConsignmentType] = useState({ ConsignmentSubTypeID: 0, SubType: tr('gsAll', 'All') })
    const [consignmentTypeOpt, setConsignmentTypeOpt] = useState([])
    const [reportData, setReportData] = useState([])
    useEffect(() => {
        focusElemnt('Select_Consignment_Type')
    }, [])
    useEffect(() => {
        if (!isEmpty(loginData)) {
            getWeightChrgList()
        }
    }, [loginData])
    useEffect(() => {
        setSelConsignmentType((prev) =>
            consignmentTypesWithAll.find((item) => item.ConsignmentSubTypeID === prev?.ConsignmentSubTypeID) || prev
        )
    }, [translations, cnsgnmntTypes])
    const addWeightChrgModal = () => {
        const data = {
            isUpdate: false,
            headText: tr('gsAddWgtChg', 'Add Weight Charge'),
            loginData: loginData,
            ConsignmentTypeList: cnsgnmntTypes
        }
        return <WeightChrgModal data={data} updateModal={updateModal} updateAlertError={updateAlertError} getWeightChrg={getWeightChrg} updateWeightChrg={updateWeightChrg} getWeightChrgList={getWeightChrgList} />
    }
    const updateWeightChrgModal = () => {
        const data = {
            isUpdate: true,
            headText: tr('gsUpdWgtChg', 'Update Weight Charge'),
            loginData: loginData,
            ConsignmentTypeList: consignmentTypeOpt
        }
        return <WeightChrgModal data={data} updateModal={updateModal} updateAlertError={updateAlertError} getWeightChrg={getWeightChrg} updateWeightChrg={updateWeightChrg} getWeightChrgList={getWeightChrgList} />
    }
    const getWeightChrgList = () => {
        setReportData([])
        if (selConsignmentType === '' || selConsignmentType === " ") {
            updateAlertError({ show: true, msg: tr('gsSelCnsErr', 'Please Select Consignment Type'), nextId: 'Select_Consignment_Type' })
        } else {
            const body = {
                CompanyID: loginData?.intCompanyID,
                ConsignmentTypeID: selConsignmentType?.ConsignmentSubTypeID
            }
            getWeightChrg(body).then((res) => {
                if (res.status === 'Success') {
                    setReportData(res.Data.Table)
                    setConsignmentTypeOpt(removeDuplicatesFromArray(res.Data.Table, "ConsignmentID").map((obj) => ({ ConsignmentSubTypeID: obj.ConsignmentID, SubType: obj.ConsignmentType })).sort((a, b) => a.SubType.localeCompare(b.SubType)))
                } else {
                    updateAlertError({ show: true, msg: res?.ErrMessage, nextId: 'Select_Consignment_Type' })
                }
            }).catch((err) => {
                console.log('Error:', err)
            })
        }
    }
    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', marginTop: '10px' }}>
                <Box sx={{ display: 'flex' }} className='itemButtons'>
                    <Item sx={sx.itemsx}>
                        <DropDownOA
                            key={`Select_Consignment_Type-${language}-${selConsignmentType?.SubType}`}
                            id={"Select_Consignment_Type"}
                            label={tr('gsSelCnsType', 'Select Consignment Type')}
                            data={consignmentTypesWithAll}
                            defaultvalue={selConsignmentType?.SubType || selConsignmentType}
                            value={selConsignmentType?.SubType || selConsignmentType}
                            onSelect={(val) => {
                                setSelConsignmentType(val)
                            }}
                            idKey={`ConsignmentSubTypeID`}
                            dataKey={`SubType`}
                            minWidth="250px"
                            prevId={`filter-1`}
                            nextId={'LoadBtn'}
                        />
                    </Item>
                    <Item sx={{ ...sx.itemsx, paddingX: '12px' }} className="disabled-wrapper">
                        <Button variant="contained" id='LoadBtn' sx={{ paddingY: '7px !important' }} className="btn btn-primary"
                            onClick={getWeightChrgList}
                            onKeyDown={(e) => navigation3(e, 'newAddBtn', 'Select_Consignment_Type', () => { })}
                        >
                            {tr('gsLoad', 'Load')}
                        </Button>
                    </Item>
                    <Item sx={{ ...sx.itemsx }} className="disabled-wrapper">
                        <Button variant="outlined" id='newAddBtn' sx={{ width: '100%' }} className="receiveitembtn" onClick={() => {
                            updateModal(true, mdt.weightChrgModal)
                        }}
                            onKeyDown={(e) => navigation3(e, 'editExisting', 'LoadBtn', () => { })}
                        >
                            {tr('gsAddNewWgt', '+ ADD NEW WEIGHT CHARGES')}
                        </Button>
                    </Item>
                    <Item sx={{ ...sx.itemsx, paddingX: '6px' }} className="disabled-wrapper">
                        <Button variant="outlined" sx={{ width: '100%' }} id='editExisting' className="receiveitembtn" onClick={() => {
                            updateModal(true, mdt.updateWeightChrgModal)
                        }}
                            onKeyDown={(e) => navigation3(e, `filter-1`, 'newAddBtn', () => { })}
                        >
                            {tr('gsEditExist', 'EDIT EXISTING')}
                        </Button>
                    </Item>
                </Box>
            </Box>
            <Box sx={{ marginTop: '15px' }}>
                <WeightChrgTable modalId={mdt.updateWeightChrgModal} updateModal={updateModal} reportData={reportData} />
            </Box>
            {showModal && mdt.weightChrgModal === modalType ? addWeightChrgModal() : null}
            {showModal && mdt.updateWeightChrgModal === modalType ? updateWeightChrgModal() : null}
            {showModal && mdt.weightChrgConfModal === modalType ? <ConfirmModal updateModal={updateModal} getWeightChrgList={getWeightChrgList}/> : null}
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateModal, updateAlertError, getWeightChrg, updateWeightChrg }
export default connect(mapStateToProps, mapDispatchToProps)(WeightCharges)
